import { motion, useReducedMotion } from "framer-motion";
export function SignalBridge() {
  const shouldReduceMotion = useReducedMotion();
  return <div className="bg-gradient-hero flex w-full items-center justify-center px-5 py-7 md:py-9" aria-hidden="true" style={{
    paddingTop: "0px",
    paddingBottom: "0px"
  }} data-id="element-354" data-mp="1ihqz0ll5gilj">
      <svg viewBox="0 0 360 48" className="h-auto w-[92%] max-w-[360px] overflow-visible" fill="none" data-id="element-355" data-mp="1s7ajfvoigkii">
        <motion.path d="
            M8 24
            C20 11 31 35 45 22
            C58 9 70 34 84 21
            C98 10 111 31 125 22
            C139 14 151 28 165 23
            C179 19 192 24 207 23
            C224 22 242 23 260 23
            L332 23
          " stroke="#C8A870" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" initial={{
        pathLength: shouldReduceMotion ? 1 : 0,
        opacity: shouldReduceMotion ? 0.9 : 0
      }} whileInView={{
        pathLength: 1,
        opacity: 0.9
      }} viewport={{
        once: true,
        amount: 0.7
      }} transition={{
        pathLength: {
          duration: shouldReduceMotion ? 0 : 1.2,
          ease: [0.22, 1, 0.36, 1]
        },
        opacity: {
          duration: shouldReduceMotion ? 0 : 0.3
        }
      }} data-id="element-356" data-mp="1x6n3y9rwtfhx" />

        <motion.circle cx="338" cy="23" r="3.4" fill="#C8A870" initial={{
        opacity: shouldReduceMotion ? 1 : 0,
        scale: shouldReduceMotion ? 1 : 0.5
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.7
      }} transition={{
        delay: shouldReduceMotion ? 0 : 1.05,
        duration: shouldReduceMotion ? 0 : 0.28,
        ease: [0.22, 1, 0.36, 1]
      }} style={{
        transformOrigin: "338px 23px"
      }} data-id="element-357" data-mp="3t1fl57q9c2pt" />
      </svg>
    </div>;
}